import React from 'react';
import { SectionContent } from '~/components/Layout/SectionContent';
import { Container, Typography, useMobileBreakpoint } from '@customink/pigment-react';
import DesktopUpload from '~/pages/Arts/Upload/DesktopUpload';
import MobileUpload from '~/pages/Arts/Upload/MobileUpload';
import { UploadBox } from './Upload/UploadBox';

const EmptyArtsList: React.FC = () => {
    const isMobile = useMobileBreakpoint();
    return (
        <SectionContent>
            <Container maxWidth="md" sx={{ textAlign: isMobile ? 'center' : 'none' }}>
                {isMobile ? (
                    <>
                        <Typography variant="heading1" weight="bold">
                            No Uploads
                        </Typography>
                        <Typography>You haven&apos;t uploaded any files yet.</Typography>
                        <MobileUpload />
                    </>
                ) : (
                    <>
                        <h2>Upload your own files</h2>
                        <p>
                            Store your group&#39;s logos, graphics, or drawings <br />
                            for easy access the next time you start a project.
                        </p>
                        <UploadBox>
                            <DesktopUpload />
                        </UploadBox>
                    </>
                )}
            </Container>
        </SectionContent>
    );
};

export default EmptyArtsList;
